<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/servicoPlano">
        Cadastro/Servico Plano Manutenção
      </router-link>
      <label class="labelBar"> / </label>
      <label> Criar</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center-left">
          <v-col cols="12" sm="6">
            <v-checkbox v-model="itemTroca" label="Item Troca"></v-checkbox>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col>
            <v-textarea
              label="Descrição *"
              v-model="descricao"
              v-uppercase
              counter
              auto-grow
              rows="1"
              :rules="[(v) => !!v || 'A Descrição é obrigatória']"
              required
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col class="text-right">
          <v-btn to="/servicoPlano" color="error" class="mr-4"> Voltar </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4"> Salvar </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import { enviarServicoPlanoAsync } from "../../../services/servicoPlanoService";
import { mapState } from "vuex";
import TabNavegacao from "../../Tabs/TabCadastroPlanoManutencao";

export default {
  name: "criarServicoPlano",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    itemTroca: false,
    active_tab: 2,
  }),
  computed: {
    ...mapState("servicoPlano", ["servicosPlano"]),
  },
  methods: {
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await enviarServicoPlanoAsync(
          this.descricao,
          this.itemTroca
        );
        if (resposta == null || resposta.status != 200) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(
            resposta.message || "",
            "Descupe, falha na operação!",
            "error"
          );
        } else {
          this.overlay = false;
          this.$router.push("/servicoPlano");
        }
      }
    },
  },
  components: {
    TabNavegacao,
  },
};
</script>
